var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _path3, _path4, _rect7, _rect8, _rect9, _path5, _path6, _rect0, _path7, _rect1, _path8, _rect10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path9, _circle1, _circle10, _circle11, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceScreenFreeMeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 147,
    viewBox: "0 0 283 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.0771,
    y: 67.9229,
    width: 9.84615,
    height: 25.8462,
    fill: "#2D2F5F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.92285,
    y: 48.2305,
    width: 54.1538,
    height: 39.3846,
    rx: 3.38462,
    fill: "#2D2F5F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1543,
    y: 90.0771,
    width: 19.6923,
    height: 3.69231,
    rx: 1.84615,
    fill: "#2D2F5F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0771 54.3848L53.9233 76.5386",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0771 76.5381L53.9233 54.3842",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 124.077,
    y: 67.9229,
    width: 9.84615,
    height: 25.8462,
    fill: "#2D2F5F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 101.923,
    y: 48.2305,
    width: 54.1538,
    height: 39.3846,
    rx: 3.38462,
    fill: "#2D2F5F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 119.154,
    y: 90.0771,
    width: 19.6923,
    height: 3.69231,
    rx: 1.84615,
    fill: "#2D2F5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.077 54.3848L149.923 76.5386",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.077 76.5381L149.923 54.3842",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 218.846,
    y: 67.1543,
    width: 12.3077,
    height: 32.3077,
    fill: "#2D2F5F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 191.154,
    y: 42.5381,
    width: 67.6923,
    height: 49.2308,
    rx: 4.23077,
    fill: "#2D2F5F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 212.692,
    y: 94.8457,
    width: 24.6154,
    height: 4.61538,
    rx: 2.30769,
    fill: "#2D2F5F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.846 50.2305L251.153 77.9228",
    stroke: "white",
    strokeWidth: 4.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.846 77.9229L251.153 50.2305",
    stroke: "white",
    strokeWidth: 4.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.5 101L157.5 105L164.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 101L61.5 105L68.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 118,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 14,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.5,
    cy: 145.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 29.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 138.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.5,
    cy: 138.5,
    r: 1.5,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 116.5L190 128",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.5,
    cy: 11.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.5,
    cy: 31.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M192 11L201.5 24.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M249 16L241.5 29.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M237 140L232 125.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceScreenFreeMeals);
export default __webpack_public_path__ + "static/media/persistence-screen-free-meals.091e5a4dad300118686379eda89f9a55.svg";
export { ForwardRef as ReactComponent };